import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';
import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET,
    RESET,
    SETSELECTED_CERNER,
    RESET_CERNER
} from 'one-state-subject/src/types';

import {
    setAction, reinitAction
} from 'one-state-pcp/src/actions';

import {
    addAction, reinitAction as resetError
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import {
    Skeleton,
} from 'one-model-local';
import {format} from 'one-util-date';
export const enum Types {
    SETPCP = 'set-pcp-data/set',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';
import { SET_CERNER } from 'one-state-patient-global-search';

const pushToSkeleton = (payload: any) => setSkeletonAction(payload);
const pushToPCP = (payload: any) => ({ type: Types.SETPCP, payload });
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Fuction will fetch the data of PCP
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchPCPCerner = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, teamName, alertnotification, settings: {
            servers,
            cernerendpoints: {
                getpcp, apitoken
            },
            compatible: { consolidated_api_invocation, contact_center_type, finesse_proxy_service },
        } } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED_CERNER),
            // ofType(Types.PatientSet),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */
                let pcppayload: any = action.payload;
                const postPCPRequest = (datares: any) => {
                    if (datares?.id) {
                        let headers = new Headers();
                        // todo need to refractor to include authorization in interface
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const patientid = {
                            "CernerID": datares?.id,
                        }
                        let response;
                        if (finesse_proxy_service) {
                            response = InvokeFinesseProxy(getpcp, patientid, apitoken, locations, log, 'POST', alertnotification);

                        } else {
                            response = server.post({
                                headers: headers,
                                path: getpcp,
                                data: patientid,
                            })
                                .then((responsefound: any) => responsefound)
                                .catch((errorpcp: any) => {
                                    log.error(
                                        "ccw-gadget,pcp-cerner",
                                        "pcp-cerner", {
                                        errorpcp
                                    }
                                    );
                                    let errorbuild: ErrorObject = {
                                        source: "PCP",
                                        type: "error",
                                        status: errorpcp?.status,
                                        erroritems: errorpcp?.errors,
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    return errorbuild;
                                })
                            log.debug(
                                "ccw-gadget,pcp-cerner",
                                "pcp-cerner response", {
                                response
                            });
                        }
                        return from(response)
                    } else {
                        return from([]);
                    }

                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                return postPCPRequest(pcppayload).
                    pipe(
                        map((response: any) => TransformResponse(response, context))
                    ).
                    pipe(
                        flatMap(pcpresponse => {
                            const actions: any = [
                                setAction(pcpresponse.pcp)];
                            if (pcpresponse.error) {
                                actions.push(addAction(pcpresponse.error));
                                let disp: Disposition = { value: "1002" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = pcppayload?.id;
                                disp.meta03 = pcpresponse?.error?.status;
                                disp.meta04 = pcpresponse?.error?.erroritems[0]?.error_detail;
                                disp.meta05 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "185" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = pcpresponse?.id;
                                disp.meta03 = '200';
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            let skeletonPatientCare: Skeleton = {
                                pendingCare_skeleton: false
                            }
                            actions.push(pushToSkeleton(skeletonPatientCare));
                            return actions;
                        })
                    )
            })
        )
    }
);

export const clearPCPCerner = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, pcp-cerner",
            "clear-PCP-cerner", {
        });
        return action$.pipe(
            ofType(SET_CERNER, SETSELECTED_CERNER, RESET, SETPATIENTSELECTED,RESET_CERNER),
            map(action => reinitAction())
        )

    }
);

export const clearErrorCerner = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, pcp-cerner",
            "clear-Error-cerner", {
        });
        return action$.pipe(
            ofType(RESET,RESET_CERNER),
            map(action => resetError())
        )

    }
);